export const namespaced = true;

export const state = {
    plots: [],
}

export const mutations = {
    FETCH_PLOTS(state, plots) {
        state.plots = plots;
    },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/plots`)).data;
            commit('FETCH_PLOTS', res.data.plots);
            return res.data.plots;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    select({ dispatch }, selectedPlot) {
        dispatch('clientOrder/setPlot', selectedPlot, { root: true })
    },

    async setDefaultPlot({ dispatch, state, rootState }) {
        await dispatch('fetch');
        if (state.plots.length) {
            let defaultPlot = state.plots.find(p => p.is_default);
            if (!defaultPlot) {
                defaultPlot = state.plots[0];
            }
            if (defaultPlot) {
                dispatch('clientOrder/setPlot', defaultPlot, { root: true })
            }
        } else {
            const length =
                rootState.settings.settings.plot_length_default ||
                rootState.settings.settings.plot_length_min;
            const width =
                rootState.settings.settings.plot_width_default ||
                rootState.settings.settings.plot_width_min;
            dispatch("clientOrder/setPlotSize", {
                length,
                width,
            }, { root: true });
        }

    }

}
